const TEMP_PASSWORD_CHARS =
  "abcdefghijkmnopqrstuvwxyzABCDEFGHJKLMNPQRSTUVWXYZ23456789!@#$%";

export function isStrongPassword(password: string): boolean {
  return (
    password.length >= 8 &&
    /[A-Z]/.test(password) &&
    /[a-z]/.test(password) &&
    /[0-9]/.test(password)
  );
}

/** Matches backend generateTemporaryPassword() — satisfies isStrongPassword(). */
export function generateTemporaryPassword(length = 12): string {
  const minLen = Math.max(length, 12);
  const bytes = new Uint8Array(minLen);
  crypto.getRandomValues(bytes);
  let password = "";
  for (let i = 0; i < minLen; i += 1) {
    password += TEMP_PASSWORD_CHARS[bytes[i]! % TEMP_PASSWORD_CHARS.length];
  }
  if (!isStrongPassword(password)) {
    return `${password.slice(0, -3)}A1a`;
  }
  return password;
}
